

import Pristine from 'pristinejs';
import flatpickr from "flatpickr";

// masonry js
//const Masonry = require('masonry-layout');
//var imagesLoaded = require('imagesloaded');


const body = document.querySelector('body')
const nav = document.querySelector('.main-nav')
const navTrigger = document.querySelector('[data-navtrigger]')


navTrigger.addEventListener('click', function(el){
	navTrigger.classList.toggle('active')
	nav.classList.toggle('open')
})

/*
var grid = document.querySelector('.masonry-block__container');
if(grid){
	var imgLoad = imagesLoaded(grid)
	imgLoad.on('always', function(){
		var msnry = new Masonry( grid, {
			itemSelector: '.masonry-block__image-container',
			columnWidth: 300,
			gutter: 17,
			fitWidth: true,
			transitionDuration: '0.15s',
		});
	})
}
*/


// glide js
import Glide from '@glidejs/glide';
if(document.querySelector('.js-slider')){
	new Glide('.js-slider', {
		type: 'carousel',
		startAt: 0,
		perView: 1,
		autoplay: 5000,
	}).mount()
}



window.onload = function () {
	// Pristine (form validation)

	// booking form validation
    var form = document.getElementById("booking-form");
	if(form){
		var config = {
			// class of the parent element where the error/success class is added
			classTo: 'form__field-container',
			errorClass: 'form__row--error',
			successClass: 'form__row--success',
			// class of the parent element where error text element is appended
			errorTextParent: 'form__field-container',
			// type of element to create for the error text
			errorTextTag: 'div',
			// class of the error text element
			errorTextClass: 'form__error'
		};

		// create the pristine instance
		var pristine = new Pristine(form, config, true);

		form.addEventListener('submit', function (e) {
		e.preventDefault();

		// check if the form is valid
		var valid = pristine.validate(); // returns true or false

		if(valid){
			form.submit();
		}
		});
	}

	// datepicker
	const pickeroptions = {
		enableTime: true,
    	dateFormat: "M j, Y \at h:iK",
		altInput: true,
    	altFormat: "M j, Y \at h:iK",
	}
	flatpickr('.js-datepicker', pickeroptions);



	// outbound link tracking
	document.querySelectorAll('.js-event-link').forEach(el => {
		el.addEventListener('click', function(ev){
			getOutboundLink(this.href)
			//window.open(this.href, '_blank').focus()
		})
	})

	var getOutboundLink = function(url) {
		gtag('event', 'click', {
			'event_category': 'outbound',
			'event_label': url,
			'transport_type': 'beacon',
		});
	}
};






